function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// lib imports
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box } from 'grommet';
import PropTypes from 'prop-types';

// CORE imports
import Alert from 'granite-admin/core/components/Alert';
import * as UserDucks from 'granite-admin/accounts/ducks/user';

// Application imports
import ALERT_MESSAGES from 'granite-admin/messages/alerts';
import { env } from 'granite-admin/env';
function initAlerts(setAlerts, userProfile) {
  const type = env.REACT_APP_REGISTER_TYPE || process.env.REACT_APP_REGISTER_TYPE;
  if (userProfile) {
    const alerts = [];
    if (!userProfile.isEmailVerified && type === 'email') {
      alerts.push({
        message: ALERT_MESSAGES.EMAIL_NOT_VERIFIED,
        showCloseBtn: false,
        link: '/verify-account',
        email: userProfile.email
      });
    }
    if (!userProfile.isPhoneVerified && type === 'phone') {
      alerts.push({
        message: ALERT_MESSAGES.PHONE_NOT_VERIFIED,
        showCloseBtn: false,
        link: '/verify-account',
        phone: userProfile?.phone?.phone
      });
    }
    setAlerts(alerts);
  }
}
const Alerts = ({
  userProfile
}) => {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => initAlerts(setAlerts, userProfile), [userProfile]);
  const handleClose = alertId => setAlerts(alerts.filter(alert => alert.id !== alertId));
  if (alerts.length === 0) return null;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "small",
    flex: {
      shrink: 0
    }
  }, alerts.map(alert => /*#__PURE__*/React.createElement(Alert, _extends({
    key: alert.message
  }, alert, {
    onClose: handleClose
  }))));
};
Alerts.propTypes = {
  userProfile: PropTypes.object
};
const mapStateToProps = state => ({
  userProfile: UserDucks.profile(state),
  selectedOrganisation: UserDucks.selectedOrganisation(state)
});
export default connect(mapStateToProps)(Alerts);